import { Controller } from "@hotwired/stimulus"

// Galerie photo d'une carte souvenir : une image visible à la fois,
// navigation par flèches et pastilles. Sans dépendance.
export default class extends Controller {
  static targets = ["photo", "dot", "prev", "next"]

  connect() {
    this.index = 0
    this.show()
  }

  next(event) {
    event?.preventDefault()
    this.index = (this.index + 1) % this.photoTargets.length
    this.show()
  }

  prev(event) {
    event?.preventDefault()
    this.index = (this.index - 1 + this.photoTargets.length) % this.photoTargets.length
    this.show()
  }

  go(event) {
    event?.preventDefault()
    this.index = Number(event.currentTarget.dataset.index)
    this.show()
  }

  show() {
    this.photoTargets.forEach((el, i) => el.classList.toggle("hidden", i !== this.index))
    this.dotTargets.forEach((el, i) => {
      const active = i === this.index
      el.classList.toggle("bg-white", active)
      el.classList.toggle("bg-white/50", !active)
      el.setAttribute("aria-current", active ? "true" : "false")
    })
  }
}
